<span nz-icon>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C8.02 2 4 3.37 4 6V18C4 20.63 8.02 22 12 22C15.98 22 20 20.63 20 18V6C20 3.37 15.98 2 12 2ZM12 4C15.72 4 18 5.29 18 6C18 6.71 15.72 8 12 8C8.28 8 6 6.71 6 6C6 5.29 8.28 4 12 4ZM12 20C8.28 20 6 18.71 6 18V16.73C7.54 17.57 9.78 18 12 18C14.22 18 16.46 17.57 18 16.73V18C18 18.71 15.72 20 12 20ZM12 16C8.28 16 6 14.71 6 14V12.73C7.54 13.57 9.78 14 12 14C14.22 14 16.46 13.57 18 12.73V14C18 14.71 15.72 16 12 16ZM12 12C8.28 12 6 10.71 6 10V8.73C7.54 9.57 9.78 10 12 10C14.22 10 16.46 9.57 18 8.73V10C18 10.71 15.72 12 12 12Z"
      fill="currentColor"
    />
  </svg>
</span>
